import { render, staticRenderFns } from "./Appeal.vue?vue&type=template&id=a6e86ace&scoped=true&"
import script from "./Appeal.vue?vue&type=script&lang=js&"
export * from "./Appeal.vue?vue&type=script&lang=js&"
import style0 from "./Appeal.vue?vue&type=style&index=0&id=a6e86ace&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e86ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
